/*! For license information please see f25combo_main.js.LICENSE.txt */ ! function() {
    var s = {
            "./src/js/main.js": function(s, e, t) {
                "use strict";
                t("jquery");
                var i = t("./src/widgets/debug.js"),
                    n = t("jquery");
                (0, i.debugfunction)();
                var o = document.documentElement.clientHeight || window.innerHeight,
                    c = document.documentElement.clientWidth || window.innerWidth,
                    a = !1,
                    r = c < 750,
                    _ = n(window).scrollTop();
                n(window).on("scroll", (function(s) {
                    var e = n(window).scrollTop();
                    e > _ ? "down" : "up", _ = e, n(n.CN(".product-container .section")).each((function(s, e) {
                            var t = n(e).data("section");
                            1 === t || 2 === t || 19 == t && function(s) {
                                var e = s.getBoundingClientRect(),
                                    t = e.top;
                                e.right, e.bottom, e.left;
                                t < 200 ? (n(n.CN(".section19_image2")).removeClass(n.CN("bigger")), n(n.CN(".section19_image5")).removeClass(n.CN("bigger"))) : (n(n.CN(".section19_image2")).addClass(n.CN("bigger")), n(n.CN(".section19_image5")).addClass(n.CN("bigger")));
                                t < -200 ? n(n.CN(".section19_image8")).removeClass(n.CN("bigger")) : n(n.CN(".section19_image8")).addClass(n.CN("bigger"))
                            }(e)
                        })), C("s20-video1", "s20-video2", l), C("s20-video4", "s20-video3", d), C("s20-video5", "s20-video6", f), C("s20-video8", null, b), C("s20-video9", null, w),
                        function() {
                            var s = document.getElementById("line-box").getBoundingClientRect(),
                                e = s.top;
                            s.right, s.bottom, s.left;
                            Math.abs(e) < o - 20 ? v.play() : v.reverse()
                        }()
                }));
                var g = new TimelineLite({
                        paused: !0
                    }),
                    m = {
                        y: 60,
                        opacity: 0
                    },
                    p = {
                        y: 0,
                        opacity: 1,
                        ease: "power2.easeOut"
                    };

                function u() {
                    return n("#play-video-text").width() / n("#play-video-line-box").width() * 100
                }
                var l = !1,
                    d = !1,
                    f = !1,
                    b = !1,
                    w = !1;

                function C(s, e, t) {
                    var i, o = document.getElementById(s).getBoundingClientRect(),
                        c = o.top,
                        a = (o.right, o.bottom, o.left, n("#" + s).get(0));
                    if (c <= 62 && a.paused && !t) {
                        if (a.play(), "s20-video9" == s && n("#s20-video7").get(0).play(), e) n("#" + e).get(0).play();
                        var r = null;
                        (r = "s20-video8" == s || "s20-video9" == s ? n("#" + s).closest(n.CN(".sub-item")).find(n.CN(".btn-play-video-sub")) : n("#" + s).closest(n.CN(".item")).find(n.CN(".btn-play-video"))) && ((i = r).css("display", "none"), setTimeout((function() {
                            i.css("opacity", 0)
                        }), 100))
                    }
                }
                n(n.CN(".section-twentieth")).find("video").on("ended", (function() {
                    switch (n(this).attr("id")) {
                        case "s20-video1":
                            l = !0;
                            break;
                        case "s20-video3":
                            d = !0;
                            break;
                        case "s20-video5":
                            f = !0;
                            break;
                        case "s20-video8":
                            b = !0;
                            break;
                        case "s20-video9":
                            w = !0
                    }
                }));
                var v = new TimelineLite({
                    paused: !0
                });
                n((function() {
                    var s, e, t, i;
                    n(n.CN(".fadein-up")).each((function() {
                            gsap.set(n(this), {
                                opacity: 0,
                                y: 40
                            }), gsap.fromTo(n(this), {
                                y: 40,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                immediateRender: !0,
                                scrollTrigger: {
                                    trigger: n(this),
                                    start: "top bottom-=" + (r ? "5%" : "15%"),
                                    end: "top+=" + (r ? 100 : 150) + " bottom-=" + (r ? "5%" : "15%"),
                                    markers: a,
                                    invalidateOnRefresh: !0,
                                    scrub: .5
                                }
                            })
                        })), n(n.CN(".container-fadein-up-list")).each((function() {
                            var s = n(this).attr("start") || "30%",
                                e = gsap.timeline({
                                    scrollTrigger: {
                                        trigger: n(this),
                                        start: "top bottom-=" + (r ? "15%" : s),
                                        end: "top+=50px bottom-=" + (r ? "15%" : "10%"),
                                        invalidateOnRefresh: !0,
                                        toggleActions: "play none reverse none"
                                    },
                                    onComplete: function() {
                                        ScrollTrigger.refresh()
                                    }
                                });
                            n(this).find(n.CN(".fadein-up-list")).each((function(s, t) {
                                gsap.set(n(t), {
                                    opacity: 0,
                                    y: 100
                                }), e.fromTo(n(t), {
                                    y: 100,
                                    opacity: 0
                                }, {
                                    y: 0,
                                    opacity: 1,
                                    duration: .5,
                                    ease: "power0.easeOut",
                                    immediateRender: !0
                                }, "<40%")
                            }))
                        })), n("".concat(n.CN(".section-line-wrap .section-line"))).each((function() {
                            gsap.set(n(this), {
                                width: 0
                            }), gsap.fromTo(n(this), {
                                width: 0
                            }, {
                                width: "100%",
                                immediateRender: !0,
                                duration: .5,
                                ease: "power2.easeOut",
                                scrollTrigger: {
                                    trigger: n(this),
                                    start: "top bottom-=" + (r ? "15%" : "30%"),
                                    end: "top+=50px bottom-=" + (r ? "15%" : "40%"),
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play none reverse none"
                                },
                                delay: Number(n(this).attr("delay")) || 0
                            })
                        })), n("".concat(n.CN(".section-title-line-wrap .section-title-line"))).each((function() {
                            gsap.set(n(this), {
                                width: 0
                            }), gsap.fromTo(n(this), {
                                width: 0
                            }, {
                                width: "100%",
                                immediateRender: !0,
                                duration: .5,
                                ease: "power2.easeOut",
                                scrollTrigger: {
                                    trigger: n(this),
                                    start: "top bottom-=" + (r ? "15%" : "30%"),
                                    end: "top+=50px bottom-=" + (r ? "15%" : "40%"),
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play none reverse none"
                                },
                                delay: Number(n(this).attr("delay")) || 0
                            })
                        })),
                        function() {
                            function s(s) {
                                return n(n.CN(".section1" + s))
                            }
                            document.querySelector('.fv_area').classList.add('active');
                            // document.getElementById("kv-video-pc").addEventListener("ended", (function() {
                            //     // console.log("视频播放已完成！"), g.play()
                                
                            // }))
                        }(), n(n.CN(".section-forth .section-wrap")).on({
                            mouseenter: function() {
                                gsap.to(n.CN(".section-forth .line-box .line-left"), 1, {
                                    width: "80%",
                                    ease: "power3.out"
                                })
                            },
                            mouseleave: function() {
                                gsap.to(n.CN(".section-forth .line-box .line-left"), 1, {
                                    width: u() + "%",
                                    ease: "power3.out"
                                })
                            }
                        }), ScrollTrigger.create({
                            animation: gsap.timeline().add(gsap.fromTo(n.CN(".section-fifth .fifth-title span"), 1, {
                                opacity: 1
                            }, {
                                opacity: .1
                            })),
                            trigger: n.CN(".section-fifth .fifth-title span"),
                            start: r ? "top bottom+=20%" : "top top+=50%",
                            end: r ? "top top+=30" : "top top+1000",
                            scrub: !0,
                            markers: a,
                            invalidateOnRefresh: !0,
                            id: "s5"
                        }), gsap.set(n.CN(".fadein-up6"), {
                            opacity: 0,
                            y: 40
                        }), gsap.fromTo(n.CN(".fadein-up6"), {
                            y: 40,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            immediateRender: !0,
                            scrollTrigger: {
                                trigger: n.CN(".fadein-up6"),
                                start: "top bottom-=" + (r ? "5%" : "15%"),
                                end: "top+=" + (r ? 100 : 150) + " bottom-=" + (r ? "5%" : "15%"),
                                invalidateOnRefresh: !0,
                                scrub: .5,
                                onEnter: function() {
                                    gsap.fromTo("#sixth-circle", 2, {
                                        strokeDasharray: "0 252"
                                    }, {
                                        strokeDasharray: "252 0",
                                        ease: "power1.out"
                                    }), gsap.fromTo(n.CN(".section-sixth .svg-box1"), 5, {
                                        width: 0
                                    }, {
                                        width: "100%",
                                        ease: "expo.out"
                                    }), n(n.CN(".section-sixth .svg-box2")).removeClass(n.CN("block-ani")), setTimeout((function() {
                                        n(n.CN(".section-sixth .svg-box2")).addClass(n.CN("block-ani"))
                                    }), 50)
                                }
                            }
                        }), s = n.CN(".section-ninth .ninth-video-box"), e = n.CN(".section-ninth .video-box"), t = n.CN(".section-ninth .video-text"), i = gsap.timeline().fromTo(s, {
                            x: "-600vw"
                        }, {
                            x: 0,
                            ease: "power1.linear",
                            duration: 10
                        }).set(s, {
                            borderRadius: 0
                        }).set(t, {
                            y: 0,
                            opacity: 1,
                            borderRadius: 0
                        }).to(s, {
                            height: r ? "25px" : "50px",
                            duration: r ? 4 : 2
                        }).add("heightGap", r ? "+=6" : "+=8").set(e, {
                            opacity: 1
                        }, "heightGap").set(s, {
                            background: "transparent"
                        }).to(s, {
                            height: r ? "168px" : "500px",
                            duration: 10
                        }), ScrollTrigger.create({
                            animation: i,
                            trigger: s,
                            start: "top top+=50%",
                            end: "top top-=450%",
                            scrub: !0,
                            markers: a,
                            invalidateOnRefresh: !0,
                            id: "line_s9"
                        }), gsap.set(n.CN(".fadein-up10"), {
                            opacity: 0,
                            y: 40
                        }), gsap.fromTo(n.CN(".fadein-up10"), {
                            y: 40,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            immediateRender: !0,
                            scrollTrigger: {
                                trigger: n.CN(".fadein-up10"),
                                start: "top bottom-=" + (r ? "5%" : "15%"),
                                end: "top+=" + (r ? 100 : 150) + " bottom-=" + (r ? "5%" : "15%"),
                                invalidateOnRefresh: !0,
                                scrub: .5,
                                onEnter: function() {
                                    gsap.fromTo("#tenth-line", 2.5, {
                                        strokeDasharray: "0 450"
                                    }, {
                                        strokeDasharray: "450 0",
                                        ease: "expo.out"
                                    })
                                }
                            }
                        }), ScrollTrigger.create({
                            animation: gsap.timeline().set(n.CN(".section-thirteenth .thirteenth-title span"), {
                                x: "30vw",
                                opacity: 0
                            }).add(gsap.fromTo(n.CN(".section-thirteenth .thirteenth-title span"), 1, {
                                x: "30vw",
                                opacity: 0
                            }, {
                                x: 0,
                                opacity: 1,
                                ease: "power1.out"
                            })),
                            trigger: n.CN(".section-thirteenth .thirteenth-title span"),
                            start: "top top+=30%",
                            end: r ? "top top-=100%" : "top top-=80%",
                            scrub: !0,
                            markers: a,
                            invalidateOnRefresh: !0,
                            id: "s13"
                        }), ScrollTrigger.create({
                            animation: gsap.timeline().add(gsap.fromTo(n.CN(".section-fourteenth .fourteenth-title span"), 1, {
                                x: 0,
                                opacity: 1
                            }, {
                                x: "-30vw",
                                opacity: 0,
                                ease: "power1.out"
                            })),
                            trigger: n.CN(".section-fourteenth .fourteenth-title span"),
                            start: r ? "top top" : "top top-=70%",
                            end: r ? "top top-=100%" : "top top-=200%",
                            scrub: !0,
                            markers: a,
                            invalidateOnRefresh: !0,
                            id: "s14"
                        }), ScrollTrigger.create({
                            animation: gsap.timeline().add(gsap.fromTo(n.CN(".section-fourteenth .full-image"), 1, {
                                height: 0
                            }, {
                                height: "auto"
                            })),
                            trigger: n.CN(".section-fourteenth .full-image"),
                            start: r ? "top bottom" : "top bottom-=300",
                            end: r ? "top top+=50%" : "",
                            scrub: !0,
                            markers: a,
                            invalidateOnRefresh: !0,
                            id: "full-image-1"
                        }), ScrollTrigger.create({
                            animation: gsap.timeline().add(gsap.fromTo(n.CN(".section-fifteenth .full-image"), 1, {
                                height: 0
                            }, {
                                height: "auto"
                            })),
                            trigger: n.CN(".section-fifteenth .full-image"),
                            start: r ? "top bottom" : "top bottom-=300",
                            end: r ? "top top+=50%" : "",
                            scrub: !0,
                            markers: a,
                            invalidateOnRefresh: !0,
                            id: "full-image-2"
                        }),
                        function() {
                            function s(s) {
                                return n(n.CN(".section-twenty-first " + s))
                            }
                            var e = {
                                    opacity: 0
                                },
                                t = {
                                    opacity: 1
                                },
                                i = {
                                    height: 0
                                },
                                o = {
                                    height: "100%"
                                };
                            v.fromTo(s(".dot1"), .2, e, t), v.fromTo(s(".line1"), .2, i, o), v.fromTo(s(".num1"), .2, e, t, .2), v.fromTo(s(".dot2"), .2, e, t, .2), v.fromTo(s(".line2"), .2, i, o, .2), v.fromTo(s(".num2"), .2, e, t, .4), v.fromTo(s(".dot3"), .2, e, t, .4), v.fromTo(s(".line3"), .2, i, o, .4), v.fromTo(s(".num3"), .2, e, t, .6), v.fromTo(s(".dot4"), .2, e, t, .6), v.fromTo(s(".line4"), .2, i, o, .6), v.fromTo(s(".num4"), .2, e, t, .8), v.fromTo(s(".dot5"), .2, e, t, .8), v.fromTo(s(".line5"), .2, i, o, .8), v.fromTo(s(".num5"), .2, e, t, 1)
                        }(), ScrollTrigger.create({
                            animation: gsap.timeline().set(n.CN(".section-twenty-third .image-left"), {
                                x: -80,
                                opacity: 0
                            }).add(gsap.fromTo(n.CN(".section-twenty-third .image-left"), 1, {
                                x: -80,
                                opacity: 0
                            }, {
                                x: 0,
                                opacity: 1,
                                ease: "power1.out"
                            })),
                            trigger: n.CN(".section-twenty-third .image-left"),
                            start: r ? "top bottom-=20" : "top bottom-=30",
                            end: "top top+=200",
                            scrub: !0,
                            markers: a,
                            invalidateOnRefresh: !0,
                            id: "s23-left"
                        }), ScrollTrigger.create({
                            animation: gsap.timeline().set(n.CN(".section-twenty-third .image-right"), {
                                x: 80,
                                opacity: 0
                            }).add(gsap.fromTo(n.CN(".section-twenty-third .image-right"), 1, {
                                x: 80,
                                opacity: 0
                            }, {
                                x: 0,
                                opacity: 1,
                                ease: "power1.out"
                            })),
                            trigger: n.CN(".section-twenty-third .image-right"),
                            start: r ? "top bottom-=20" : "top bottom-=30",
                            end: "top top+=200",
                            scrub: !0,
                            markers: a,
                            invalidateOnRefresh: !0,
                            id: "s23-right"
                        })
                })), window.onload = function() {
                    n("#play-video-line").css("width", u() + "%"),
                        function() {
                            if (r)
                                for (var s = 0; s < 9; s++) document.getElementById("s20-video".concat(s + 1)).load();

                            function e(s, e) {
                                s.parent().find(e).each((function() {
                                    var e = n(this).get(0);
                                    e && (e.play(), s.css("opacity", 0), setTimeout((function() {
                                        s.css("display", "none")
                                    }), 600))
                                }))
                            }
                            n(n.CN(".btn-play-video")).on("click", (function() {
                                e(n(this), "video")
                            })), n(n.CN(".btn-play-video-sub")).on("click", (function() {
                                e(n(this), "video")
                            })), n(n.CN(".listen-video")).each((function() {
                                n(this).on("ended", (function() {
                                    console.log("视频播放已完成！");
                                    var s = n(this).closest(n.CN(".item")).find(n.CN(".btn-play-video")),
                                        e = n(this).closest(n.CN(".sub-item")).find(n.CN(".btn-play-video-sub"));

                                    function t(s) {
                                        s.css("display", "block"), setTimeout((function() {
                                            s.css("opacity", 1)
                                        }), 100)
                                    }
                                    s && t(s), e && t(e)
                                }))
                            }))
                        }()
                }, n(window).on("resize", (function(s) {}))
            },
            "./src/widgets/AlbumCart/index.js": function(s, e, t) {
                "use strict";

                function i() {
                    document.documentElement.clientWidth || window.innerWidth;
                    // var s = new Swiper("#albumSwiper", {
                    //     loop: !0,
                    //     effect: "cards",
                    //     grabCursor: !0
                    // });
                    // document.querySelector("#albumSwiper").addEventListener("click", (function() {
                    //     s.slideNext()
                    // }))
                }
                t.d(e, {
                    default: function() {
                        return i
                    }
                })
            },
            "./src/widgets/Album/index.js": function(s, e, t) {
                "use strict";

                function i() {
                    document.documentElement.clientWidth || window.innerWidth;
                    // new Swiper("#qSwiperalbum", {
                    //     grabCursor: !0,
                    //     speed: 2e4,
                    //     loop: !0,
                    //     slidesPerView: "auto",
                    //     a11y: {
                    //         slideRole: "listitem"
                    //     },
                    //     autoplay: {
                    //         pauseOnMouseEnter: !0,
                    //         disableOnInteraction: !1,
                    //         delay: 0
                    //     }
                    // }), new Swiper("#qSwiperalbum-1", {
                    //     grabCursor: !0,
                    //     speed: 16e3,
                    //     loop: !0,
                    //     slidesPerView: "auto",
                    //     a11y: {
                    //         slideRole: "listitem"
                    //     },
                    //     autoplay: {
                    //         pauseOnMouseEnter: !0,
                    //         disableOnInteraction: !1,
                    //         delay: 0
                    //     }
                    // })
                }
                t.d(e, {
                    default: function() {
                        return i
                    }
                })
            },
            "./src/widgets/ClassExtension.js": function(s, e, t) {
                ! function(s) {
                    s.extend({
                        CN: function(s) {
                            return s.startsWith(".") ? s.split(" ").map((function(s) {
                                return s.startsWith(".") ? ".".concat("f25combo_").concat(s.slice(1)) : s
                            })).join(" ") : "f25combo_" + s
                        }
                    })
                }(t("jquery"))
            },
            "./src/widgets/ContrastContainer/index.js": function(s, e, t) {
                "use strict";
                var i = t("jquery");

                function n(s, e) {
                    return function(s) {
                        if (Array.isArray(s)) return s
                    }(s) || function(s, e) {
                        var t = null == s ? null : "undefined" != typeof Symbol && s[Symbol.iterator] || s["@@iterator"];
                        if (null != t) {
                            var i, n, o, c, a = [],
                                r = !0,
                                _ = !1;
                            try {
                                if (o = (t = t.call(s)).next, 0 === e) {
                                    if (Object(t) !== t) return;
                                    r = !1
                                } else
                                    for (; !(r = (i = o.call(t)).done) && (a.push(i.value), a.length !== e); r = !0);
                            } catch (s) {
                                _ = !0, n = s
                            } finally {
                                try {
                                    if (!r && null != t.return && (c = t.return(), Object(c) !== c)) return
                                } finally {
                                    if (_) throw n
                                }
                            }
                            return a
                        }
                    }(s, e) || function(s, e) {
                        if (!s) return;
                        if ("string" == typeof s) return o(s, e);
                        var t = Object.prototype.toString.call(s).slice(8, -1);
                        "Object" === t && s.constructor && (t = s.constructor.name);
                        if ("Map" === t || "Set" === t) return Array.from(s);
                        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return o(s, e)
                    }(s, e) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function o(s, e) {
                    (null == e || e > s.length) && (e = s.length);
                    for (var t = 0, i = new Array(e); t < e; t++) i[t] = s[t];
                    return i
                }
                i((function() {
                    var s = document.documentElement.clientWidth || window.innerWidth;
                    ! function() {
                        if (document.getElementById("compare_data")) {
                            var e, t = JSON.parse(document.getElementById("compare_data").text),
                                o = (e = t, JSON.parse(JSON.stringify(e)));
                            c(t), i(i.CN(".contrast-container")).on("click", i.CN(".h4"), (function() {
                                var s = this;
                                i(i.CN(".contrast-container .h4")).each((function(e, t) {
                                    t !== s && i(t).children(i.CN(".popup")).hide()
                                })), i(this).children(i.CN(".popup")).toggle()
                            })), i(document).on("click", (function(s) {
                                i(s.target).closest(i.CN(".contrast-container .h4")).length || i(i.CN(".contrast-container .popup")).hide()
                            })), i(i.CN(".contrast-container")).on("click", i.CN(".h4 .modlist"), (function(s) {
                                var e = i(this).attr("productname"),
                                    n = i(this).attr("parentlevel");
                                o[n] = t[e], c(o)
                            }))
                        }

                        function c(e) {
                            var o = "";
                            Object.entries(e).forEach((function(e, i) {
                                var c = n(e, 2),
                                    a = c[0],
                                    r = c[1];
                                i > (s > 750 ? 2 : 1) || (o += '<div class="'.concat("f25combo_", 'item">\n          <img src="').concat(r.imgsrc, '" alt="').concat(r.name, '">\n          <div class="').concat("f25combo_", 'h4">').concat(r.name, '\n            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M1.5 1L6.5 6L11.5 1" stroke="#DB2D30" stroke-width="2" stroke-linecap="round"/>\n            </svg>\n            <div class="').concat("f25combo_", 'popup">\n              <div class="').concat("f25combo_", 'models">').concat(r.choose, "</div>"), Object.entries(t).forEach((function(s) {
                                    var e = n(s, 2),
                                        t = e[0],
                                        i = e[1];
                                    o += '<p class="'.concat("f25combo_", 'modlist" parentlevel="').concat(a, '" productname="').concat(t, '">\n                <svg class="').concat(r.name == i.name ? "".concat("f25combo_", "active") : "", '" width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n                  <path d="M1.33346 3L4.33354 6L10.0002 1" stroke="black" stroke-width="1.5" stroke-linecap="round"/>\n                </svg><span>').concat(i.name, "</span></p>")
                                })), o += "</div>\n          </div>\n          <div>", r.open_purchase ? o += '<button class="'.concat("f25combo_", 'buy-now purchase-sales-channel-btn" product-name="').concat(r.name.replaceAll(" ", "-").replaceAll("Roborock-", ""), '" data-toggle="modal" data-target="#product-sales-channel">').concat(r.btntext, "</button>") : r.show_link_btn ? o += '<a href="'.concat(r.btn_link, '"><button class="').concat("f25combo_", 'buy-now">').concat(r.btntext, "</button></a>") : o += '<div class="'.concat("f25combo_", 'no_btn"></div>'), o += "</div>\n          <ul>", Object.entries(r).forEach((function(s) {
                                    var e = n(s, 2),
                                        t = e[0],
                                        i = e[1];
                                    t.includes("item") && (o += "<li>".concat(i, "</li>"))
                                })), o += "</ul>\n        </div>")
                            })), i("#compare-table").html(o), "function" == typeof ReloadSalesChannelEvents && ReloadSalesChannelEvents()
                        }
                    }()
                }))
            },
            "./src/widgets/FullScreenVideo/index.js": function(s, e, t) {
                "use strict";
                var i = t("jquery");
                i((function() {
                    function s() {
                        i(i.CN(".full_screen_video")).hide();
                        var s = new window.CustomEvent("hide.all.modals");
                        document.dispatchEvent(s)
                    }! function() {
                        var s = document.querySelectorAll(i.CN(".as-youtube-video"));
                        if (s.length > 0) {
                            var e = document.createElement("script");
                            e.src = "https://www.youtube.com/iframe_api";
                            var t = document.getElementsByTagName("script")[0];
                            t.parentNode.insertBefore(e, t);
                            var n = [],
                                o = function(s) {
                                    document.addEventListener("hide.all.modals", (function(s) {
                                        for (var e = 0; e < n.length; e++) n[e].pauseVideo()
                                    }))
                                };
                            window.onYouTubeIframeAPIReady = function() {
                                for (var e = 0; e < s.length; e++) n.push(new window.YT.Player(s[e], {
                                    events: {
                                        onReady: o
                                    }
                                }))
                            }
                        }
                    }(), i(i.CN(".section-forth .video-box")).on("click", (function(s) {
                        i(i.CN(".full_screen_video")).show()
                    })), i(i.CN(".full_screen_video")).on("click", (function(e) {
                        s()
                    })), i(i.CN(".full_screen_video .video-close")).on("click", (function(e) {
                        s()
                    }))
                }))
            },
            "./src/widgets/LeftNav/index.js": function(s, e, t) {
                "use strict";
                t("jquery")
            },
            "./src/widgets/SeriseContainer/index.js": function(s, e, t) {
                "use strict";
                var i = t("jquery");
                i((function() {
                    i("#sideBtn").on("click", (function() {
                        var s = i(i.CN(".serise-container"));
                        s.hasClass(i.CN("show")) ? s.addClass(i.CN("hide")).removeClass(i.CN("show")) : s.addClass(i.CN("show")).removeClass(i.CN("hide"))
                    })), i("#popup-tab").delegate(i.CN(".tabTitle"), "click", (function(s) {
                        i(this).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".tabbody .tabCard")).eq(i(this).index()).show().siblings().hide(), i(i.CN(".pc .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".mob .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active"))
                    }))
                }))
            },
            "./src/widgets/basics.js": function(s, e, t) {
                "use strict";
                t.d(e, {
                    basics: function() {
                        return n
                    }
                });
                var i = t("jquery");

                function n() {
                    i(".ad-bar").length > 0 && i(i.CN(".container")).css({
                        "margin-top": "110px"
                    }), i("#product_subscription_b").on("click", (function() {
                        i("#subscribe-modal").css({
                            display: "block"
                        })
                    }))
                }
            },
            "./src/widgets/debug.js": function(s, e, t) {
                "use strict";
                t.d(e, {
                    debugfunction: function() {
                        return n
                    }
                });
                var i = t("jquery");

                function n() {
                    var s, e, t, n, o, c, a, r, _ = null,
                        g = !1;

                    function m() {
                        if (_) {
                            var s = document.documentElement.clientHeight || window.innerHeight,
                                e = document.documentElement.clientWidth || window.innerWidth;
                            _.text("屏幕分辨率: ".concat(e, " x ").concat(s))
                        }
                    }
                    // s = window.location.href, e = new URL(s), t = e.hostname, n = e.searchParams.get("debugResolution"), !(o = /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/).test(t) && !/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}|:):(([0-9a-fA-F]{1,4}:){1,7}|:))$/.test(t) && "show" != n || (g || ((_ = i("<div>", {
                    //     id: "resolution-container",
                    //     style: "position:fixed;top:10px;left:10px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);",
                    //     text: "屏幕分辨率: 加载中..."
                    // })).appendTo("body"), g = !0), m(), o.test(t)), i(window).resize((c = m, a = 200, r = 0, function() {
                    //     var s = (new Date).getTime();
                    //     s - r >= a && (r = s, c.apply(void 0, arguments))
                    // }))
                }
            },
            "./src/widgets/index.js": function(s, e, t) {
                "use strict";
                t("./src/widgets/ContrastContainer/index.js"), t("./src/widgets/FullScreenVideo/index.js"), t("./src/widgets/LeftNav/index.js"), t("./src/widgets/SeriseContainer/index.js"), t("./src/widgets/ClassExtension.js");
                var i = t("./src/widgets/Album/index.js"),
                    n = t("./src/widgets/AlbumCart/index.js"),
                    o = t("./src/widgets/basics.js");
                (0, i.default)(), (0, n.default)(), (0, o.basics)()
            },
            "./src/index.html": function(s, e, t) {
                "use strict";
                var i = t("./node_modules/html-loader/dist/runtime/getUrl.js"),
                    n = t.n(i),
                    o = new URL(t("./src/assets/video/section1_KV.mp4"), t.b),
                    c = new URL(t("./src/assets/images/section1_KV_image_m.jpg"), t.b),
                    a = new URL(t("./src/assets/images/section2_IF_Awards_Logo.jpg"), t.b),
                    r = new URL(t("./src/assets/images/section2_no_place_out.png"), t.b),
                    _ = new URL(t("./src/assets/images/section2_no_place_out_m.png"), t.b),
                    g = new URL(t("./src/assets/images/section2_wet_and_dry.png"), t.b),
                    m = new URL(t("./src/assets/images/section2_wet_and_dry_m.png"), t.b),
                    p = new URL(t("./src/assets/images/section2_JawScrapers.png"), t.b),
                    u = new URL(t("./src/assets/images/section2_JawScrapers_m.png"), t.b),
                    l = new URL(t("./src/assets/images/section2_complete_clean.png"), t.b),
                    d = new URL(t("./src/assets/images/section2_complete_clean_m.png"), t.b),
                    f = new URL(t("./src/assets/images/section2_drying_roller.png"), t.b),
                    b = new URL(t("./src/assets/images/section2_drying_roller_m.png"), t.b),
                    w = new URL(t("./src/assets/images/section2_SlideTech.png"), t.b),
                    C = new URL(t("./src/assets/images/section2_SlideTech_m.png"), t.b),
                    v = new URL(t("./src/assets/images/section2_intelligent_app.png"), t.b),
                    h = new URL(t("./src/assets/images/section2_intelligent_app_m.png"), t.b),
                    x = new URL(t("./src/assets/images/section3_family.png"), t.b),
                    y = new URL(t("./src/assets/images/section3_family_m.png"), t.b),
                    R = new URL(t("./src/assets/video/section4_video.mp4"), t.b),
                    F = new URL(t("./src/assets/video/section4_video_m.mp4"), t.b),
                    L = new URL(t("./src/assets/images/section19_image1.png"), t.b),
                    j = new URL(t("./src/assets/images/section19_image1_m.png"), t.b),
                    U = new URL(t("./src/assets/images/section19_image2.png"), t.b),
                    N = new URL(t("./src/assets/images/section19_image2_m.png"), t.b),
                    T = new URL(t("./src/assets/images/section19_image3.png"), t.b),
                    k = new URL(t("./src/assets/images/section19_image3_m.png"), t.b),
                    S = new URL(t("./src/assets/images/section19_image4.png"), t.b),
                    E = new URL(t("./src/assets/images/section19_image4_m.png"), t.b),
                    O = new URL(t("./src/assets/images/section19_image5.png"), t.b),
                    A = new URL(t("./src/assets/images/section19_image5_m.png"), t.b),
                    q = new URL(t("./src/assets/images/section19_image6.png"), t.b),
                    I = new URL(t("./src/assets/images/section19_image7.png"), t.b),
                    B = new URL(t("./src/assets/images/section19_image7_m.png"), t.b),
                    W = new URL(t("./src/assets/images/section19_image8.png"), t.b),
                    V = new URL(t("./src/assets/images/section19_image8_m.png"), t.b),
                    J = new URL(t("./src/assets/images/section19_image9.png"), t.b),
                    M = new URL(t("./src/assets/images/section19_image9_m.png"), t.b),
                    D = new URL(t("./src/assets/images/section19_image10.png"), t.b),
                    P = new URL(t("./src/assets/images/section19_image10_m.png"), t.b),
                    K = new URL(t("./src/assets/images/section19_image11.png"), t.b),
                    H = new URL(t("./src/assets/images/section20_image1.jpg"), t.b),
                    $ = new URL(t("./src/assets/video/section20_video_1.mp4"), t.b),
                    z = new URL(t("./src/assets/video/section20_video_2.mp4"), t.b),
                    G = new URL(t("./src/assets/video/section20_video_3.mp4"), t.b),
                    Y = new URL(t("./src/assets/video/section20_video_4.mp4"), t.b),
                    Q = new URL(t("./src/assets/images/section20_sign1.png"), t.b),
                    X = new URL(t("./src/assets/video/section20_video_5.mp4"), t.b),
                    Z = new URL(t("./src/assets/video/section20_video_6.mp4"), t.b),
                    ss = new URL(t("./src/assets/video/section20_video_7.mp4"), t.b),
                    es = new URL(t("./src/assets/video/section20_video_8.mp4"), t.b),
                    ts = new URL(t("./src/assets/video/section20_video_9.mp4"), t.b),
                    is = new URL(t("./src/assets/video/section6_video_1.mp4"), t.b),
                    ns = new URL(t("./src/assets/images/section6_sign1.png"), t.b),
                    os = new URL(t("./src/assets/images/section6_data_icon1.png"), t.b),
                    cs = new URL(t("./src/assets/images/section6_data1_line_bg.png"), t.b),
                    as = new URL(t("./src/assets/images/section6_data1_line_bg_m.png"), t.b),
                    rs = new URL(t("./src/assets/images/section6_data_icon2.png"), t.b),
                    _s = new URL(t("./src/assets/images/section6_data2_line_bg1.png"), t.b),
                    gs = new URL(t("./src/assets/images/section6_data_icon3.png"), t.b),
                    ms = new URL(t("./src/assets/images/section6_data2_line_bg2.png"), t.b),
                    ps = new URL(t("./src/assets/images/section7_sign1.png"), t.b),
                    us = new URL(t("./src/assets/video/section7_video_1.mp4"), t.b),
                    ls = new URL(t("./src/assets/images/section7_data_icon1.png"), t.b),
                    ds = new URL(t("./src/assets/images/section7_data_icon2.png"), t.b),
                    fs = new URL(t("./src/assets/images/section8_bg.png"), t.b),
                    bs = new URL(t("./src/assets/images/section8_bg_m.png"), t.b),
                    ws = new URL(t("./src/assets/images/section8_sign1.png"), t.b),
                    Cs = new URL(t("./src/assets/images/section9_image_1.jpg"), t.b),
                    vs = new URL(t("./src/assets/images/section10_img1.jpg"), t.b),
                    hs = new URL(t("./src/assets/images/section10_img1_m.jpg"), t.b),
                    xs = new URL(t("./src/assets/images/section10_icon4.png"), t.b),
                    ys = new URL(t("./src/assets/images/section10_icon3.png"), t.b),
                    Rs = new URL(t("./src/assets/images/section10_icon2.png"), t.b),
                    Fs = new URL(t("./src/assets/images/section10_icon1.png"), t.b),
                    Ls = new URL(t("./src/assets/images/section11_img1.png"), t.b),
                    js = new URL(t("./src/assets/video/section12_video_1.mp4"), t.b),
                    Us = new URL(t("./src/assets/video/section12_video_1_m.mp4"), t.b),
                    Ns = new URL(t("./src/assets/video/section13_video_1.mp4"), t.b),
                    Ts = new URL(t("./src/assets/video/section13_video_2.mp4"), t.b),
                    ks = new URL(t("./src/assets/video/section13_video_3.mp4"), t.b),
                    Ss = new URL(t("./src/assets/video/section14_video_1.mp4"), t.b),
                    Es = new URL(t("./src/assets/video/section14_video_1_m.mp4"), t.b),
                    Os = new URL(t("./src/assets/images/section14_sign1.png"), t.b),
                    As = new URL(t("./src/assets/images/section14_sign1_m.png"), t.b),
                    qs = new URL(t("./src/assets/images/section14_full_image1.jpg"), t.b),
                    Is = new URL(t("./src/assets/images/section14_full_image1_m.jpg"), t.b),
                    Bs = new URL(t("./src/assets/images/section15_bg1.png"), t.b),
                    Ws = new URL(t("./src/assets/images/section15_bg1_m.png"), t.b),
                    Vs = new URL(t("./src/assets/images/section15_bg2.png"), t.b),
                    Js = new URL(t("./src/assets/images/section15_bg2_m.png"), t.b),
                    Ms = new URL(t("./src/assets/images/section15_custom_icon1.png"), t.b),
                    Ds = new URL(t("./src/assets/images/section15_bg3.png"), t.b),
                    Ps = new URL(t("./src/assets/images/section15_bg3_m.png"), t.b),
                    Ks = new URL(t("./src/assets/images/section15_custom_icon2.png"), t.b),
                    Hs = new URL(t("./src/assets/images/section15_full_image1.jpg"), t.b),
                    $s = new URL(t("./src/assets/images/section15_full_image1_m.jpg"), t.b),
                    zs = new URL(t("./src/assets/images/section21_image1.jpg"), t.b),
                    Gs = new URL(t("./src/assets/images/section21_image1_m.jpg"), t.b),
                    Ys = new URL(t("./src/assets/images/section21_image2.png"), t.b),
                    Qs = new URL(t("./src/assets/images/section21_image2_m.png"), t.b),
                    Xs = new URL(t("./src/assets/images/section21_image3.jpg"), t.b),
                    Zs = new URL(t("./src/assets/images/section21_image3_m.jpg"), t.b),
                    se = new URL(t("./src/assets/images/section21_image4.png"), t.b),
                    ee = new URL(t("./src/assets/images/section21_image4_m.png"), t.b),
                    te = new URL(t("./src/assets/images/section22_image1.png"), t.b),
                    ie = new URL(t("./src/assets/images/section22_image1_m.png"), t.b),
                    ne = new URL(t("./src/assets/images/section23_image1.jpg"), t.b),
                    oe = new URL(t("./src/assets/images/section23_image2.jpg"), t.b),
                    ce = new URL(t("./src/assets/images/section_compare_F25_Combo.png"), t.b),
                    ae = new URL(t("./src/assets/images/section_compare_F25_ACE_Combo.png"), t.b),
                    re = new URL(t("./src/assets/images/section22_image_1.jpg"), t.b),
                    _e = new URL(t("./src/assets/images/section22_image_2.jpg"), t.b),
                    ge = new URL(t("./src/assets/images/section22_image_3.jpg"), t.b),
                    me = new URL(t("./src/assets/images/section22_image_4.jpg"), t.b),
                    pe = new URL(t("./src/assets/images/section22_image_5.jpg"), t.b),
                    ue = new URL(t("./src/assets/images/section22_image_6.jpg"), t.b),
                    le = new URL(t("./src/assets/images/section22_image_7.jpg"), t.b),
                    de = new URL(t("./src/assets/images/section22_image_8.jpg"), t.b),
                    fe = new URL(t("./src/assets/images/section22_image_9.jpg"), t.b),
                    be = new URL(t("./src/assets/images/section22_image_10.jpg"), t.b),
                    we = new URL(t("./src/assets/images/section22_image_11.jpg"), t.b),
                    Ce = new URL(t("./src/assets/images/section22_image_12.jpg"), t.b),
                    ve = new URL(t("./src/assets/images/section22_image_13.jpg"), t.b),
                    he = new URL(t("./src/assets/images/section22_image_14.jpg"), t.b),
                    xe = new URL(t("./src/assets/images/section22_image_15.jpg"), t.b);
                n()(o), n()(c), n()(a), n()(r), n()(_), n()(g), n()(m), n()(p), n()(u), n()(l), n()(d), n()(f), n()(b), n()(w), n()(C), n()(v), n()(h), n()(x), n()(y), n()(R), n()(F), n()(L), n()(j), n()(U), n()(N), n()(T), n()(k), n()(S), n()(E), n()(O), n()(A), n()(q), n()(I), n()(B), n()(W), n()(V), n()(J), n()(M), n()(D), n()(P), n()(K), n()(H), n()($), n()(z), n()(G), n()(Y), n()(Q), n()(X), n()(Z), n()(ss), n()(es), n()(ts), n()(is), n()(ns), n()(os), n()(cs), n()(as), n()(rs), n()(_s), n()(gs), n()(ms), n()(ps), n()(us), n()(ls), n()(ds), n()(fs), n()(bs), n()(ws), n()(Cs), n()(vs), n()(hs), n()(xs), n()(ys), n()(Rs), n()(Fs), n()(Ls), n()(js), n()(Us), n()(Ns), n()(Ts), n()(ks), n()(Ss), n()(Es), n()(Os), n()(As), n()(qs), n()(Is), n()(Bs), n()(Ws), n()(Vs), n()(Js), n()(Ms), n()(Ds), n()(Ps), n()(Ks), n()(Hs), n()($s), n()(zs), n()(Gs), n()(Ys), n()(Qs), n()(Xs), n()(Zs), n()(se), n()(ee), n()(te), n()(ie), n()(ne), n()(oe), n()(ce), n()(ae), n()(re), n()(_e), n()(ge), n()(me), n()(pe), n()(ue), n()(le), n()(de), n()(fe), n()(be), n()(we), n()(Ce), n()(ve), n()(he), n()(xe)
            },
            "./node_modules/html-loader/dist/runtime/getUrl.js": function(s) {
                "use strict";
                s.exports = function(s, e) {
                    return e || (e = {}), s ? (s = String(s.__esModule ? s.default : s), e.hash && (s += e.hash), e.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(s) ? '"'.concat(s, '"') : s) : s
                }
            },
            "./src/assets/images/section10_icon1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section10_icon1.png"
            },
            "./src/assets/images/section10_icon2.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section10_icon2.png"
            },
            "./src/assets/images/section10_icon3.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section10_icon3.png"
            },
            "./src/assets/images/section10_icon4.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section10_icon4.png"
            },
            "./src/assets/images/section10_img1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section10_img1.jpg"
            },
            "./src/assets/images/section10_img1_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section10_img1_m.jpg"
            },
            "./src/assets/images/section11_img1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section11_img1.png"
            },
            "./src/assets/images/section14_full_image1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section14_full_image1.jpg"
            },
            "./src/assets/images/section14_full_image1_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section14_full_image1_m.jpg"
            },
            "./src/assets/images/section14_sign1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section14_sign1.png"
            },
            "./src/assets/images/section14_sign1_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section14_sign1_m.png"
            },
            "./src/assets/images/section15_bg1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_bg1.png"
            },
            "./src/assets/images/section15_bg1_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_bg1_m.png"
            },
            "./src/assets/images/section15_bg2.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_bg2.png"
            },
            "./src/assets/images/section15_bg2_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_bg2_m.png"
            },
            "./src/assets/images/section15_bg3.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_bg3.png"
            },
            "./src/assets/images/section15_bg3_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_bg3_m.png"
            },
            "./src/assets/images/section15_custom_icon1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_custom_icon1.png"
            },
            "./src/assets/images/section15_custom_icon2.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_custom_icon2.png"
            },
            "./src/assets/images/section15_full_image1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_full_image1.jpg"
            },
            "./src/assets/images/section15_full_image1_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section15_full_image1_m.jpg"
            },
            "./src/assets/images/section19_image1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image1.png"
            },
            "./src/assets/images/section19_image10.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image10.png"
            },
            "./src/assets/images/section19_image10_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image10_m.png"
            },
            "./src/assets/images/section19_image11.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image11.png"
            },
            "./src/assets/images/section19_image1_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image1_m.png"
            },
            "./src/assets/images/section19_image2.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image2.png"
            },
            "./src/assets/images/section19_image2_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image2_m.png"
            },
            "./src/assets/images/section19_image3.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image3.png"
            },
            "./src/assets/images/section19_image3_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image3_m.png"
            },
            "./src/assets/images/section19_image4.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image4.png"
            },
            "./src/assets/images/section19_image4_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image4_m.png"
            },
            "./src/assets/images/section19_image5.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image5.png"
            },
            "./src/assets/images/section19_image5_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image5_m.png"
            },
            "./src/assets/images/section19_image6.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image6.png"
            },
            "./src/assets/images/section19_image7.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image7.png"
            },
            "./src/assets/images/section19_image7_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image7_m.png"
            },
            "./src/assets/images/section19_image8.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image8.png"
            },
            "./src/assets/images/section19_image8_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image8_m.png"
            },
            "./src/assets/images/section19_image9.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image9.png"
            },
            "./src/assets/images/section19_image9_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section19_image9_m.png"
            },
            "./src/assets/images/section1_KV_image_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section1_KV_image_m.jpg"
            },
            "./src/assets/images/section20_image1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_image1.jpg"
            },
            "./src/assets/images/section20_sign1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_sign1.png"
            },
            "./src/assets/images/section21_image1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section21_image1.jpg"
            },
            "./src/assets/images/section21_image1_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section21_image1_m.jpg"
            },
            "./src/assets/images/section21_image2.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section21_image2.png"
            },
            "./src/assets/images/section21_image2_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section21_image2_m.png"
            },
            "./src/assets/images/section21_image3.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section21_image3.jpg"
            },
            "./src/assets/images/section21_image3_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section21_image3_m.jpg"
            },
            "./src/assets/images/section21_image4.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section21_image4.png"
            },
            "./src/assets/images/section21_image4_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section21_image4_m.png"
            },
            "./src/assets/images/section22_image1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image1.png"
            },
            "./src/assets/images/section22_image1_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image1_m.png"
            },
            "./src/assets/images/section22_image_1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_1.jpg"
            },
            "./src/assets/images/section22_image_10.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_10.jpg"
            },
            "./src/assets/images/section22_image_11.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_11.jpg"
            },
            "./src/assets/images/section22_image_12.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_12.jpg"
            },
            "./src/assets/images/section22_image_13.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_13.jpg"
            },
            "./src/assets/images/section22_image_14.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_14.jpg"
            },
            "./src/assets/images/section22_image_15.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_15.jpg"
            },
            "./src/assets/images/section22_image_2.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_2.jpg"
            },
            "./src/assets/images/section22_image_3.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_3.jpg"
            },
            "./src/assets/images/section22_image_4.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_4.jpg"
            },
            "./src/assets/images/section22_image_5.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_5.jpg"
            },
            "./src/assets/images/section22_image_6.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_6.jpg"
            },
            "./src/assets/images/section22_image_7.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_7.jpg"
            },
            "./src/assets/images/section22_image_8.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_8.jpg"
            },
            "./src/assets/images/section22_image_9.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section22_image_9.jpg"
            },
            "./src/assets/images/section23_image1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section23_image1.jpg"
            },
            "./src/assets/images/section23_image2.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section23_image2.jpg"
            },
            "./src/assets/images/section2_IF_Awards_Logo.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_IF_Awards_Logo.jpg"
            },
            "./src/assets/images/section2_JawScrapers.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_JawScrapers.png"
            },
            "./src/assets/images/section2_JawScrapers_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_JawScrapers_m.png"
            },
            "./src/assets/images/section2_SlideTech.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_SlideTech.png"
            },
            "./src/assets/images/section2_SlideTech_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_SlideTech_m.png"
            },
            "./src/assets/images/section2_complete_clean.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_complete_clean.png"
            },
            "./src/assets/images/section2_complete_clean_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_complete_clean_m.png"
            },
            "./src/assets/images/section2_drying_roller.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_drying_roller.png"
            },
            "./src/assets/images/section2_drying_roller_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_drying_roller_m.png"
            },
            "./src/assets/images/section2_intelligent_app.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_intelligent_app.png"
            },
            "./src/assets/images/section2_intelligent_app_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_intelligent_app_m.png"
            },
            "./src/assets/images/section2_no_place_out.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_no_place_out.png"
            },
            "./src/assets/images/section2_no_place_out_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_no_place_out_m.png"
            },
            "./src/assets/images/section2_wet_and_dry.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_wet_and_dry.png"
            },
            "./src/assets/images/section2_wet_and_dry_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section2_wet_and_dry_m.png"
            },
            "./src/assets/images/section3_family.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section3_family.png"
            },
            "./src/assets/images/section3_family_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section3_family_m.png"
            },
            "./src/assets/images/section6_data1_line_bg.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section6_data1_line_bg.png"
            },
            "./src/assets/images/section6_data1_line_bg_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section6_data1_line_bg_m.png"
            },
            "./src/assets/images/section6_data2_line_bg1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section6_data2_line_bg1.png"
            },
            "./src/assets/images/section6_data2_line_bg2.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section6_data2_line_bg2.png"
            },
            "./src/assets/images/section6_data_icon1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section6_data_icon1.png"
            },
            "./src/assets/images/section6_data_icon2.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section6_data_icon2.png"
            },
            "./src/assets/images/section6_data_icon3.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section6_data_icon3.png"
            },
            "./src/assets/images/section6_sign1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section6_sign1.png"
            },
            "./src/assets/images/section7_data_icon1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section7_data_icon1.png"
            },
            "./src/assets/images/section7_data_icon2.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section7_data_icon2.png"
            },
            "./src/assets/images/section7_sign1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section7_sign1.png"
            },
            "./src/assets/images/section8_bg.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section8_bg.png"
            },
            "./src/assets/images/section8_bg_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section8_bg_m.png"
            },
            "./src/assets/images/section8_sign1.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section8_sign1.png"
            },
            "./src/assets/images/section9_image_1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section9_image_1.jpg"
            },
            "./src/assets/images/section_compare_F25_ACE_Combo.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section_compare_F25_ACE_Combo.png"
            },
            "./src/assets/images/section_compare_F25_Combo.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section_compare_F25_Combo.png"
            },
            "./src/assets/video/section12_video_1.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section12_video_1.mp4"
            },
            "./src/assets/video/section12_video_1_m.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section12_video_1_m.mp4"
            },
            "./src/assets/video/section13_video_1.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section13_video_1.mp4"
            },
            "./src/assets/video/section13_video_2.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section13_video_2.mp4"
            },
            "./src/assets/video/section13_video_3.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section13_video_3.mp4"
            },
            "./src/assets/video/section14_video_1.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section14_video_1.mp4"
            },
            "./src/assets/video/section14_video_1_m.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section14_video_1_m.mp4"
            },
            "./src/assets/video/section1_KV.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section1_KV.mp4"
            },
            "./src/assets/video/section20_video_1.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_video_1.mp4"
            },
            "./src/assets/video/section20_video_2.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_video_2.mp4"
            },
            "./src/assets/video/section20_video_3.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_video_3.mp4"
            },
            "./src/assets/video/section20_video_4.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_video_4.mp4"
            },
            "./src/assets/video/section20_video_5.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_video_5.mp4"
            },
            "./src/assets/video/section20_video_6.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_video_6.mp4"
            },
            "./src/assets/video/section20_video_7.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_video_7.mp4"
            },
            "./src/assets/video/section20_video_8.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_video_8.mp4"
            },
            "./src/assets/video/section20_video_9.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section20_video_9.mp4"
            },
            "./src/assets/video/section4_video.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section4_video.mp4"
            },
            "./src/assets/video/section4_video_m.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section4_video_m.mp4"
            },
            "./src/assets/video/section6_video_1.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section6_video_1.mp4"
            },
            "./src/assets/video/section7_video_1.mp4": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/f25combo_section7_video_1.mp4"
            },
            jquery: function(s) {
                "use strict";
                s.exports = $
            }
        },
        e = {};

    function t(i) {
        var n = e[i];
        if (void 0 !== n) return n.exports;
        var o = e[i] = {
            exports: {}
        };
        return s[i](o, o.exports, t), o.exports
    }
    t.m = s, t.n = function(s) {
            var e = s && s.__esModule ? function() {
                return s.default
            } : function() {
                return s
            };
            return t.d(e, {
                a: e
            }), e
        }, t.d = function(s, e) {
            for (var i in e) t.o(e, i) && !t.o(s, i) && Object.defineProperty(s, i, {
                enumerable: !0,
                get: e[i]
            })
        }, t.o = function(s, e) {
            return Object.prototype.hasOwnProperty.call(s, e)
        }, t.p = "/cdn/shop/", t.b = document.baseURI || self.location.href,
        function() {
            "use strict";
            t("./src/index.html"), t("./src/widgets/index.js"), t("./src/js/main.js")
        }()
}();